import { Fragment } from 'react';
import styled from 'styled-components';
import { caption, colors } from 'ui/theme';
import { UsageLinkedName } from './Styled';
import { Content, SecondaryCaption } from '../../campaignIndex/components/CampaignNameCell.styles';
import { SnippetUsage } from '../types';
import { getReferenceUrl } from '../utils';

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
`;

const CellContentText = styled.div`
  display: flex;
  flex-direction: column;
`;

const CellContentTextCaption = styled.span`
  ${caption}
  color: ${colors.textSecondary};
`;

type Props = {
  result: SnippetUsage;
};
export const UsageNameCell = ({ result }: Props) => {
  const { campaignID, name, id } = result;

  const referenceUrl = getReferenceUrl(result);

  return (
    <Fragment key={id}>
      <Cell data-test={`usage-${id}-name-cell`}>
        <Content data-test="usage-content">
          <UsageLinkedName
            to={referenceUrl}
            data-test={`reference-name-link-${id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {name}
          </UsageLinkedName>
        </Content>

        <CellContentText>
          <CellContentTextCaption>
            <SecondaryCaption data-test="usage-detail-key">ID: {campaignID || id}</SecondaryCaption>
          </CellContentTextCaption>
        </CellContentText>
      </Cell>
    </Fragment>
  );
};
